<template>
    <div class="group relative border rounded-lg overflow-hidden shadow hover:shadow-md transition">
        <img
            :src="src"
            alt="Document"
            class="w-full h-40 object-cover"
        />
        <div
            class="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center space-x-4"
        >
            <button @click="$emit('view', src)">
                <ViewIcon class="w-6 h-6 text-white hover:text-green-400 transition transform hover:scale-125" />
            </button>
            <button @click="$emit('download', src)">
                <DownloadIcon class="w-6 h-6 text-white hover:text-green-400 transition transform hover:scale-125" />
            </button>
        </div>
        <div class="p-2 text-sm text-gray-700 font-medium">
            {{ title }}
        </div>
    </div>
</template>

<script>
    import DownloadIcon from '@/Components/Icons/DownloadIcon.vue';
    import ViewIcon from '@/Components/Icons/ViewIcon.vue';

    export default {
        name: 'DocumentCard',
        props: {
            title: {
                type: String,
                default: '',
            },
            src: String,
        },
        components: {
            ViewIcon,
            DownloadIcon,
        },
    };
</script>
